import { useTokenStore } from '@/src/common/store/useTokenStore'
import * as Application from 'expo-application'
import { Platform } from 'react-native'
import { z } from 'zod/v4'
import Constants from 'expo-constants'
import { useDeviceId } from '@/src/common/hooks/useDeviceId'
import { environment } from '@/src/common/environment'

const platformVersion = z.coerce.string().safeParse(Platform.Version)
const platformConstants = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  (z.looseObject({}) as unknown as z.ZodType<typeof Platform.constants>).safeParse(
    Platform.constants,
  )

type MesaApiRequestHeaders = Record<string, string>

/** we should use a standard way of conveying emptiness. neither `null`, `undefined`, `'null'`, `'undefined'`, nor `'unknown'`, etc. seem to fit the bill */
const EMPTY_HEADER = '' satisfies keyof MesaApiRequestHeaders

const staticMesaHeaders = {
  ...(environment === 'production'
    ? undefined
    : { 'ngrok-skip-browser-warning': '1', 'bypass-tunnel-reminder': '1' }),
  'X-Mesa-App-Version': Constants.expoConfig?.version ?? EMPTY_HEADER,
  'X-Mesa-App-ID': Application.applicationId ?? EMPTY_HEADER,
  'X-Mesa-App-Native-Version': Application.nativeApplicationVersion ?? EMPTY_HEADER,
  'X-Mesa-App-Native-Build-Number': Application.nativeBuildVersion ?? EMPTY_HEADER,
  'X-Mesa-Platform-OS': Platform.OS,
  'X-Mesa-Platform-Version': platformVersion.data ?? EMPTY_HEADER,
  'X-Mesa-Platform-RN-Version': platformConstants.data
    ? (`${platformConstants.data.reactNativeVersion.major}.${platformConstants.data.reactNativeVersion.minor}.${platformConstants.data.reactNativeVersion.patch}` as const)
    : EMPTY_HEADER,
} as const satisfies MesaApiRequestHeaders

export function getMesaApiRequestHeaders() {
  const deviceId = useDeviceId.getState()
  const accessToken = useTokenStore.getState().tokens?.accessToken
  return {
    ...staticMesaHeaders,
    'X-Mesa-Device-ID': typeof deviceId === 'string' ? deviceId : EMPTY_HEADER,
    authorization: accessToken ? (`Bearer ${accessToken}` as const) : EMPTY_HEADER,
  } as const satisfies MesaApiRequestHeaders
}
